import { numberFormatter } from "@opensea/i18n"

const format = numberFormatter("en-US")

export function formatPrice(value: number) {
  return format(value, { display: "usd-compact" })
}
